import classnames from 'classnames';
import { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import MyDetails from './MyDetails';
import AccountBank from './AccountBank';
import ResetPassword from './Security';
// import Agreement from './Agreement';
import { useDict } from '../../../contexts/LanguageContext';

const ListProfile = (props) => {
    const { profileData, isFetching, setIsLoading } = props;

    const dict = useDict();

    const [activeTab, setActiveTab] = useState('1');

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <>
            <div className="tabs tabs--bordered-bottom my-3">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '1',
                                'd-flex align-items-center h-100': true,
                            })}
                            onClick={() => {
                                toggle('1');
                            }}
                            data-cy="myProfile__navLink--myDetails"
                        >
                            <span
                                style={{ fontWeight: 'bold', color: '#264391' }}
                            >
                                {dict.myDetails}
                            </span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '2',
                                'd-flex align-items-center h-100': true,
                            })}
                            onClick={() => {
                                toggle('2');
                            }}
                            data-cy="myProfile__navLink--bankAccount"
                        >
                            <span
                                style={{ fontWeight: 'bold', color: '#264391' }}
                            >
                                {dict.bankAccount}
                            </span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '3',
                                'd-flex align-items-center h-100': true,
                            })}
                            onClick={() => {
                                toggle('3');
                            }}
                            data-cy="myProfile__navLink--security"
                        >
                            <span
                                style={{ fontWeight: 'bold', color: '#264391' }}
                            >
                                {dict.security}
                            </span>
                        </NavLink>
                    </NavItem>
                    {/* <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '4',
                                'd-flex align-items-center h-100': true,
                            })}
                            onClick={() => {
                                toggle('4');
                            }}
                            data-cy="myProfile__navLink--agreement"
                        >
                            <span
                                style={{ fontWeight: 'bold', color: '#264391' }}
                            >
                                {dict.agreement}
                            </span>
                        </NavLink>
                    </NavItem> */}
                </Nav>
            </div>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <MyDetails profileData={profileData} />
                </TabPane>
                <TabPane tabId="2">
                    <AccountBank
                        bankAccountData={
                            profileData?.wallets?.[0]?.bank_accounts || null
                        }
                        isFetching={isFetching}
                    />
                </TabPane>
                <TabPane tabId="3">
                    <ResetPassword setIsLoading={setIsLoading} />
                </TabPane>
                {/* <TabPane tabId="4" style={{ minHeight: '50vh' }}>
                    <Agreement />
                </TabPane> */}
                <br />
            </TabContent>
        </>
    );
};

export default ListProfile;
